module.exports = __webpack_public_path__ + "static/zoë-foster-blake-7ec122cdce289a2a278e8b85d07f5a7e.jpg";